import { AppBar, Toolbar } from '@mui/material';
import { useContext, useEffect } from 'react';
import { IncPageContext } from '../inc-page.context';

const IncPageFooter = ({ children, ...rest }) => {
  const { setHasFooter } = useContext(IncPageContext);

  useEffect(() => {
    setHasFooter(true);
  }, [setHasFooter]);

  return (
    <AppBar
      position="sticky"
      data-testid="IncPageFooter"
      component="footer"
      sx={{
        top: 'auto',
        bottom: 0,
        mx: -2,
        mb: -2,
        width: 'auto',
        '.MuiButton-root:not(:first-of-type)': { ml: 2 },
      }}
      color="default"
      {...rest}
    >
      <Toolbar>{children}</Toolbar>
    </AppBar>
  );
};
export default IncPageFooter;
